import { FGEmpty, FGNumberInput, FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { CompetitionRequestDto, CountryApi, ERequestState } from "../../../../api";
import { FGCountrySelect, FGSRSHCheckboxInput, FGSRSHDateMaskInput } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { FormikProps } from "formik";

export interface IDrupalCompetitionRequestFormProps {
  competitionRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalCompetitionRequestForm: React.FunctionComponent<IDrupalCompetitionRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const countryApi = useApiService(CountryApi);

  const [clubs, cloading] = useReferential((a) => a.getClubs(null), true, []);
  const [sections, sloading] = useReferential((a) => a.getSections(), true, []);
  const [activities, aloading] = useReferential((a) => a.getActivities(initialdata.sectionId), true);
  const [subActivities, saloading] = useReferential((a) => a.getSubActivities(initialdata.activityId), true);
  const [cities, pcloading] = useReferential((a) => a.getPostalCodes(), true, []);

  const formikRef = React.useRef<FormikProps<CompetitionRequestDto>>();

  const isBelgium = React.useMemo(
    async () => (!!initialdata.countryId ? await countryApi.isBelgian(initialdata.countryId) : null),
    [countryApi, initialdata.countryId]
  );

  return (
    <DrupalFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
      formikInnerRef={(f) => (formikRef.current = f)}
    >
      <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
        <div>
          <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} requiredMark />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} readonly={true} />
            </FieldGroup>
          )}
        </div>
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGSelectInput name="clubId" label={t(ETLCodes.Club)} items={clubs} loading={cloading} />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGTextInput name="clubEmail" label={t(ETLCodes.ClubEmail)} />
      </FieldGroup>
      <FieldGroup columns={3}>
        <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} />
        <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} />
        {initialdata?.request?.status === ERequestState.REQUESTED ? (
          <FGEmpty />
        ) : (
          <FGSRSHDateMaskInput name="catalogReceptionDate" label={t(ETLCodes.CatalogReception)} />
        )}
        <FGSelectInput name="sectionId" label={t(ETLCodes.Section)} items={sections} loading={sloading} />
        <FGSelectInput name="activityId" label={t(ETLCodes.Activity)} items={activities} loading={aloading} />
        {initialdata?.request?.status === ERequestState.REQUESTED ? (
          <FGEmpty />
        ) : (
          <FGNumberInput name="numberParticipants" label={t(ETLCodes.ParticipantsCount)} />
        )}
        <FGSelectInput name="subActivityId" label={t(ETLCodes.SubActivity)} items={subActivities} loading={saloading} />
        <FGTextInput name="extra" label={t(ETLCodes.Extra)} />
        <FGEmpty />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGTextInput name="clubAddress" label={t(ETLCodes.ClubAddress)} readonly />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGSRSHCheckboxInput name="otherAddress" label={t(ETLCodes.OtherAddress)} />
      </FieldGroup>
      <FieldGroup columns={2}>
        <FGCountrySelect name="countryId" label={t(ETLCodes.Country)} visible={initialdata.otherAdress} requiredMark />
      </FieldGroup>
      <FieldGroup columns={2}>
        {isBelgium ? (
          <FGSelectInput
            name="postalCodeId"
            label={t(ETLCodes.City)}
            items={cities}
            loading={pcloading}
            visible={!!formikRef?.current?.values?.otherAddress}
          />
        ) : (
          <FGTextInput
            name="foreignCity"
            label={t(ETLCodes.City)}
            visible={!!formikRef?.current?.values?.otherAddress}
          />
        )}
      </FieldGroup>
      <DrupalStepperButtonBloc backOnly={true} />
    </DrupalFormGenerator>
  );
};
